var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4898 23.4844H18.5769V24.8451H20.4898V23.4844Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40338 23.4844H3.49048V24.8451H5.40338V23.4844Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10425 20.9902C1.10425 21.8974 1.83391 22.627 2.74106 22.627H21.2193C22.1264 22.627 22.8561 21.8974 22.8561 20.9902V15.0938H1.10425V20.9902Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16105 11.6352V1.89318C4.16105 1.40016 4.61463 0.986031 5.1668 0.986031C5.6401 0.986031 6.03451 1.28184 6.15283 1.67625L5.32457 2.50452C5.18652 2.64256 5.14708 2.85949 5.22597 3.03698C5.26541 3.1553 5.36401 3.23418 5.46261 3.29334L4.85127 4.43714C4.71323 4.67379 4.81183 4.9696 5.04848 5.10764C5.12736 5.14708 5.20624 5.1668 5.28513 5.1668C5.46261 5.1668 5.6401 5.0682 5.71898 4.91044L6.19228 4.02301V5.00904C6.19228 5.28513 6.4092 5.50205 6.68529 5.50205C6.96138 5.50205 7.17831 5.28513 7.17831 5.00904V4.02301L7.6516 4.91044C7.75021 5.0682 7.90797 5.1668 8.08546 5.1668C8.16434 5.1668 8.24322 5.14708 8.3221 5.10764C8.55875 4.9696 8.65735 4.67379 8.51931 4.43714L7.90797 3.29334C8.00657 3.23418 8.10518 3.1553 8.14462 3.03698C8.2235 2.85949 8.18406 2.64256 8.04601 2.50452L7.15859 1.61709C7.00082 0.709942 6.17255 0 5.1668 0C4.06245 0 3.17502 0.847987 3.17502 1.89318V11.6352H0V14.1002H24V11.6352H4.16105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathW);
export default __webpack_public_path__ + "static/media/BathW.9b54fd6aef3b240ec368974a61d2fad2.svg";
export { ForwardRef as ReactComponent };